import { useMemo } from 'react';
import { LOCALE_TO_COUNTRY_CODE_MAP } from '@zep-us/i18n';

import { useLocale } from '@/hooks';

import { getPresetsForCountry } from '../constants';

const PRESET_DISPLAY_COUNT = 3;

export const usePresetPrompts = () => {
  const { locale } = useLocale();

  // Get country-specific presets (or US fallback)
  const allPresets = getPresetsForCountry(LOCALE_TO_COUNTRY_CODE_MAP[locale]);

  const presets = useMemo(() => {
    const shuffled = [...allPresets].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, PRESET_DISPLAY_COUNT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return { presets };
};
